import React, { useContext } from 'react';
import {
	Combobox,
	ComboboxInput,
	ComboboxList,
	ComboboxOption,
	ComboboxPopover,
} from '@reach/combobox';
import usePlacesAutocomplete, {
	getGeocode,
	getLatLng,
} from 'use-places-autocomplete';
import '@reach/combobox/styles.css';
import styled from 'styled-components';

import Store from '../../utils/Store';

const SearchBoxOne = () => {
	const { dispatch } = useContext(Store);
	const {
		ready,
		value,
		suggestions: { status, data },
		setValue,
		clearSuggestions,
	} = usePlacesAutocomplete({
		requestOptions: {
			location: { lat: () => 43.6532, lng: () => -79.3832 },
			radius: 100 * 1000,
		},
	});

	const handleInput = (e) => {
		setValue(e.target.value);
	};

	const handleSelect = async (address) => {
		setValue(address, false);
		clearSuggestions();

		try {
			let results = await getGeocode({ address });

			// console.log(results);

			let { lat, lng } = await getLatLng(results[0]);
			let origin = { lat, lng };
			// console.log(lat, lng);
			dispatch({ type: 'ORIGIN', payload: origin });
		} catch (error) {
			console.log('😱 Error: ', error);
		}
	};

	// const handleSubmit = (e) => {
	// 	e.preventDefault();
	// 	console.log('Hello', e.target.value);
	// };

	return (
		<SearchBox>
			<Combobox onSelect={handleSelect}>
				<ComboboxInput
					value={value}
					onChange={handleInput}
					disabled={!ready}
					placeholder='Search your Origin'
				/>
				<ComboboxPopover>
					<ComboboxList>
						{status === 'OK' &&
							data.map(({ description }) => (
								<ComboboxOption key={Math.random()} value={description} />
							))}
					</ComboboxList>
				</ComboboxPopover>
			</Combobox>
			{/* <button type='submit'>submit</button> */}
		</SearchBox>
	);
};

export default SearchBoxOne;
const SearchBox = styled.div`
	margin-bottom: 10px;
	input {
		padding: 0.5rem;
		font-size: 1.2rem;
		border-radius: 4px;
		border: none;
	}
`;
